import { render, staticRenderFns } from "./UpdateAlert.vue?vue&type=template&id=2ce19141&scoped=true&"
import script from "./UpdateAlert.vue?vue&type=script&lang=js&"
export * from "./UpdateAlert.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAlert.vue?vue&type=style&index=0&id=2ce19141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce19141",
  null
  
)

export default component.exports